import { FleekError } from './FleekError';

type PrivateGateway = {
  id?: string;
  slug?: string;
  name?: string;
};

type PrivateGatewayNotFoundErrorOptions = {
  privateGateway: PrivateGateway;
};

export class PrivateGatewayNotFoundError extends FleekError<PrivateGatewayNotFoundErrorOptions> {
  public name = 'PrivateGatewayNotFoundError';

  toString = () => `Private gateway not found.`;
}
